var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFilledReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#F60"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.8 3.2v13.055c0 2.29-1.857 4.145-4.147 4.145H5.2v-1.73L16.144 7.228V8.72c0 .359.293.65.656.65.362 0 .655-.291.655-.65V5.472l-.005-.024c-.001-.047-.015-.09-.028-.136-.01-.037-.014-.076-.03-.11s-.041-.061-.063-.092c-.028-.04-.053-.08-.088-.112-.006-.006-.009-.014-.015-.019-.024-.02-.053-.027-.078-.043-.04-.026-.078-.052-.123-.069-.044-.015-.087-.019-.132-.026-.032-.004-.06-.018-.093-.018h-3.278c-.363 0-.656.29-.656.65 0 .358.293.649.656.649h1.852L5.2 16.745 5.2 3.2h13.6z",
    transform: "translate(-286 -1209) translate(286 1209)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilledReport);
export default __webpack_public_path__ + "static/media/icon-filled-report.83b619a6c2d3949b1e902721f4f7e563.svg";
export { ForwardRef as ReactComponent };